<template>
  <div :class="{ hideTemplate: hidePanel }">
    <div @click="vivoxInfo = !vivoxInfo">Vivox</div>
    <div v-show="vivoxInfo">
      <div>
        <button @click="vivoxSDKInit(uid)">clientInit</button>
        <button @click="terminateLoginSession()">clientOut</button>
        <button @click="joinChannel()">JoinCh.</button>
        <button @click="leaveChannelSession(false)">leaveCh.</button>
        <button @click="vSend">Test</button>
        <br />
        <label> <input type="checkbox" v-model="wdWatch" />wdWatch </label>
        <label> <input type="checkbox" v-model="micEnabled" />micEnabled </label>
      </div>
      inputDeviceId:{{ inputDeviceId }}
      <br />
      client:{{ clientState }}
      <br />
      Vivox:{{ vivoxState }}
      <br />
      channelCntingTimer:{{ channelCntingTimer }},channelDisCntingTimer:{{ channelDisCntingTimer }}
      <br />
      watchdog:{{ wdWatch }},changeChannelDelay:{{ changeChannelDelay }}
      <br />
      received name:{{ receiveChannel }}
      <br />
      entered name:{{ wdenterChannelName }}
      <br />
      uid:{{ uid }}, random uid:{{ udiRandom }}
      <br />
      reConnect:{{ reConnect }} <br />mute value:
      <input v-model="muteValue" size="5" />
      <br />live users:
      <div class="vLiveUsers" v-for="(item, i) in liveUsers" :key="i">
        {{ i + 1 }} userid:{{ item.account.name }}, {lastGain:{{item.clientLastGain}},muted:{{item.clientMuted}}},muted:
        {{ item.localMute == 1 }}
        <button
          @click="setMuteForMeByName(item.account.name, item.localMute == 0)"
        >
          set mute {{ item.localMute == 0 }}
        </button>
      </div>
      <div style="display: none">
        <ul id="sessionlist"></ul>
        <li class="sessitem">
          <div class="sesshead">
            <span class="sesscontrols" />
            <span class="sessname" />
            <span class="sessstreams" />
          </div>
          <ul class="partslist" />
          <div class="groupchat" />
          <div class="groupchatsend" />
          <div class="audiolist" />
        </li>
      </div>
    </div>
    
  </div>
</template>

<script>
import Vivox5WebRTC from "@/assets/vivox5webrtc.js";
import eventBus from "../eventBus";

export default {
  components: { eventBus },
  name: "Vivox",
  props: {
    hidePanel: { type: Boolean, default: false },
    receiveChannel: { type: String, default: "default" },
    spatial: { type: Boolean, default: false },
    uid: { type: String, default: "" },
    micEnabled: { type: Boolean, default: false },
    cntStatus: { type: Object, default: {} },
    vivoxEnable: { type: Boolean, default: false },
    zoneNeedConnect: { type: Boolean, default: false },
    wdWatch: { type: Boolean, default: false },
    wdCheckTime: { type: Number, default: 5000 },
    speakers: { type: Array, default: [] },
    subscribeMode: { type: Boolean, default: false },
  },
  data() {
    return {
      inputDeviceId: "default",
      Vivox5: null,
      vivoxInitialized: false,
      clientState: "DISCONNECTED",
      vivoxState: "DISCONNECTED",
      clientCntingCount: 0,
      channelCntingTimer: 0,
      channelCntingTimerFun: null,
      channelDisCntingTimer: 0,
      channelDisCntingTimerFun: null,
      VOICECHAT_TARGET: "INTERNAL_VOICECHAT",
      VOICECHAT_REALM: "mt2p.vivox.com",
      // VOICECHAT_REALM: 'wrtcd.www.vivox.com',
      ACCESS_TOKEN_ISSUER: "sinewaveenterta-space",
      ACCESS_TOKEN_KEY: "aa0gvFeTjJVa2i0FBaEkXhgwIGJmo0TJ",
      ACCESS_TOKEN_DURATION: 1200, // Default token validity in seconds
      LOG_RECORDS_LIMIT: 500, // Records limit in the log window
      loginSession: null, // Vivox5.LoginSession (singleton in this demo app)
      channelSession: {},
      streamLocal: null, // Local audio stream from the user's microphone (obtained using getUserMedia())
      vivoxInfo: false,

      udiRandom: "",
      wdenterChannelName: "",
      reConnect: false,
      liveUsers: [],
      muteValue: 0,
      obj2KeyValueDepth: 5,
      watchdogFun: null,
      changeChannelDelay: false,
    };
  },
  computed: {
    state: function () {
      return this.loginSession && this.loginSession.isConnected;
    },
  },
  watch: {
    vivoxState: function (val, oldVal) {
      console.log("val", val);
      console.log("oldVal", oldVal);
      this.$emit("updateStatus", val);
    },
    clientCntingCount: function (val) {
      console.log("clientCntingCount,", val);
      if (val > 2) {
        this.clientCntingCount = 0;
        this.reConnect = true;
        this.terminateLoginSession();
      }
    },
    micEnabled: function (val) {
      console.log("v micEnabled:" + val);
      if (val) {
        this.enableMic();
      } else {
        this.disableMic();
      }
    },
    receiveChannel: function (val) {
      if (this.vivoxEnable) {
        let that=this;
        console.log("v receiveChannel:" + val + ', but it need watchdog to handle');
        that.changeChannelDelay = true
        clearInterval(that.watchdogFun);
        setTimeout(() => {
          console.log("run time out 2s")
          that.watchdog();
          that.changeChannelDelay = false
          that.watchdogFun = setInterval(that.watchdog, that.wdCheckTime);
        }, 2000);
      }
    },
    speakers: function (val) {
      if (val.length > 0) {
        console.log("v computed mutedUsers:", val);
        this.setMuteForMe(val);
      }
    },
    inputDeviceId: function (val) {
      this.terminateLoginSession();
      // var configGetUserMedia = {
      //   video: false,
      //   audio: { deviceId: val },
      // };
      // console.log(configGetUserMedia);

      // navigator.mediaDevices
      //   .getUserMedia(configGetUserMedia)
      //   .then(this.onGetUserMediaSuccess)
      //   .catch(this.onGetUserMediaError);
    },
  },
  created: function () {
    this.receiveDeviceId();
  },
  mounted: function () {
    let that = this;
    this.Vivox5 = Vivox5WebRTC.Vivox5;

    this.watchdogFun = setInterval(this.watchdog, this.wdCheckTime);
  },
  methods: {
    vSend: function () {
      if(this.vivoxState=='CONNECTED'){

        this.channelSession.disconnect();
      }
    },
    watchdog: function () {
      // console.log("vwatchdog run");
      let that=this;
      if (that.wdWatch) {
        if (that.vivoxState == that.cntStatus.cnted) {
          this.streamLocal.getAudioTracks().forEach(function (track) {
            if (track.enabled != that.micEnabled) {
              console.log("vWD: micEnabled state error, set micEnabled:" + that.micEnabled);
              track.enabled = that.micEnabled;
            }
          });
        }

        if(that.channelCntingTimer>=4){
          that.$parent.resetConnect();
          that.channelCntingTimer=0;
          clearInterval(that.channelCntingTimerFun);
          return;
        }

        if (
          (that.vivoxState == that.cntStatus.cnting ||
            that.vivoxState == that.cntStatus.cnted) &&
          that.wdenterChannelName == that.receiveChannel
        ) {
          console.log(
            "vWD:status is " +
              that.vivoxState +
              " and checking name is ==,return"
          );
          return;
        }
        if (that.wdenterChannelName != that.receiveChannel) {
          console.warn(
            "vWD:check channel error," +
              that.receiveChannel +
              " ? " +
              that.wdenterChannelName
          );
          if (that.vivoxState == that.cntStatus.cnted) {
            that.leaveChannelSession(true);
          } else if (that.vivoxState == that.cntStatus.dcnted) {
            that.joinChannel();
          }
        } else if (
          that.wdenterChannelName == that.receiveChannel &&
          that.wdenterChannelName != ""
        ) {
          if (that.vivoxState == that.cntStatus.dcnted) {
            console.warn("vWD:same channel, join when disconnected");
            that.joinChannel();
          }
        }
      } else {
        if(that.channelDisCntingTimer>=4){
          that.$parent.resetConnect();
          that.channelDisCntingTimer=0;
          clearInterval(that.channelDisCntingTimerFun);
          return;
        }
        if (that.vivoxState == that.cntStatus.cnted) {
          console.warn("vWD:leaveChannel when connected");
          that.leaveChannelSession(false);
        }
        that.closeDevice();
      }
    },
    channelCntingCount: function() {
      this.channelCntingTimer++;
    },
    channelDisCntingCount: function() {
      this.channelDisCntingTimer++;
    },
    //vivox client
    vivoxSDKInit: function (uid) {
      this.initVivox5(); // Initialize Vivox5 WebRTC JS SDK -- mandatory
      this.initUserMedia(); // Connect to the multimedia subsystem (microphone) in the Web Browser -- mandatory
      try {
        this.initiateLoginSession(
          uid,
          this.VOICECHAT_REALM,
          this.ACCESS_TOKEN_ISSUER,
          this.ACCESS_TOKEN_KEY
        );
      } catch (error) {
        this.vivoxState = this.cntStatus.dcnted;
        console.log("initiateLoginSession error:", error);
      }
    },
    initVivox5: function () {
      if (this.vivoxInitialized) {
        console.log("vivox client is vivoxInitialized");
        return;
      }
      this.clientState = this.cntStatus.cnting;
      // console.log(Vivox5WebRTC.Vivox5);return;
      // Set logging callbacks. Just for development and debugging. In production version the logging may be disabled.
      Vivox5WebRTC.Vivox5.loggerInfo = this.log;
      Vivox5WebRTC.Vivox5.loggerTraf = this.logTraffic;

      // Initialize Vivox5.Client object (mandatory)
      this.vivoxInitialized = Vivox5WebRTC.Vivox5.Client.initialize();
      if (!this.vivoxInitialized) {
        console.error("Failed to initialize Vivox5 Client");
      }

      // Some tips to demo users
      Vivox5WebRTC.Vivox5.log(
        "DEMOAPP",
        "Just for information: XMPP traffic is logged to the browser console"
      );
      Vivox5WebRTC.Vivox5.log(
        "DEMOAPP",
        "Just for information: try to open popup menus with right-click on buddy list items, active session items and session participants"
      );
    },
    initUserMedia() {
      // Connect to the multimedia subsystem (microphone) in the Web Browser. This is mandatory for this application to work.
      // Note: getUserMedia can call the success or failure callback after a very long time (after the user to confirm or deny to use the microphone),
      // so, using an initialization timeout is not a good solution in this place.
      // if (this.streamLocal != null) {
      //   console.log("streamLocal is initialized");
      //   return;
      // }

      var configGetUserMedia = {
        video: false,
        audio: {
          deviceId: this.inputDeviceId,
          // noiseSuppression: true,
          // echoCancellation: true,
          // echoCancellationType: { ideal: "system" }
        },
      };
      console.warn(configGetUserMedia);

      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(configGetUserMedia)
          .then(this.onGetUserMediaSuccess)
          .catch(this.onGetUserMediaError);
      } else {
        this.onGetUserMediaError(
          "The browser does not support getUserMedia() API"
        );
      }
    },
    onGetUserMediaError: function (error) {
      // Here we get if access to the microphone failed. The application cannot work anymore.
      this.streamLocal = null;

      var errorString = "getUserMedia() failure";
      if (error) {
        errorString += ": ";
        errorString += error.toString();
      }
      console.error(errorString);
    },
    initiateLoginSession: function (userId, realm, issuer, key) {
      // Here we create the LoginSession -- the communication channel with the Vivox servers.
      // Steps:
      // 1. Instantiate Vivox5.LoginSession object.
      // 2. Set callback functions for essential events (connected/disconnected, channels added/removed, messages received, presence subscriptions, etc.).
      // 3. Start LoginSession.
      // This function is called when a user clicks the 'Connect' button (see function onClickConnect below)

      if (this.loginSession) {
        console.log("loginSession already connecting or connected");
        // already connecting or connected
        return;
      }

      // Create new Vivox5.LoginSession object
      let rnd = this.getRndInteger(100, 999);
      userId = "u" + userId + "a" + rnd;
      this.udiRandom = userId;
      var accountId = new Vivox5WebRTC.Vivox5.AccountId(issuer, userId, realm);
      this.loginSession = Vivox5WebRTC.Vivox5.Client.getLoginSession(
        accountId,
        window.location.protocol == "https:",
        undefined
      );
      if (!this.loginSession) {
        console.log("Failed to create LoginSession");
        return;
      }

      // Setup loginSession callbacks
      this.loginSession.onConnected = this.onConnected;
      this.loginSession.onDisconnected = this.onDisconnected;
      this.loginSession.onConnFailure = this.onDisconnected;
      this.loginSession.onChannelSessionRemoved = this.onChannelSessionRemoved;
      this.loginSession.onDirectedTextMessage = this.onDirectedTextMessage;

      this.loginSession.onIncomingSubscriptionRequest = this.onIncomingSubscriptionRequest;
      this.loginSession.onBuddyPresence = this.onBuddyPresence;
      this.loginSession.onBuddyAdded = this.onBuddyAdded;
      this.loginSession.onBuddyRemoved = this.onBuddyRemoved;

      // Start loginSession
      var loginAccessToken = this.loginSession.getLoginToken(
        key,
        this.ACCESS_TOKEN_DURATION
      );
      var rc = this.loginSession.login(loginAccessToken, 2);

      if (!rc) {
        console.log("LoginSession failed, see details in the log");
        loginSession = null;
      }
    },
    terminateLoginSession: function (reConnect = false) {
      // LoginSession termintaion
      if (!this.isConnected()) {
        return;
      }
      this.clientState = this.cntStatus.dcnting;
      this.loginSession.logout();
    },
    isConnected: function () {
      // returns true if Vivox5.LoginSession object is instantiated and the session is connected, false otherwise.
      return this.loginSession && this.loginSession.isConnected;
    },
    onConnected: function (_loginSession) {
      // Vivox5.LoginSession.onConnected callback handler -- called when the LoginSession is connected
      console.log("onConnected:", _loginSession);
      this.clientState = this.cntStatus.cnted;
      console.log("onConnected state:", this.vivoxState);
      if (this.reConnect) {
        this.reConnect = false;
        this.joinChannel();
      }
    },
    onDisconnected: function (_loginSession) {
      if (this.loginSession) {
        this.loginSession = null;
      }
      console.log("onDisconnected:", _loginSession);
      this.clientState = this.cntStatus.dcnted;
    },
    onChannelSessionRemoved: function (_loginSession, channelSession) {
      // Vivox5.LoginSession.onChannelSessionRemoved callback handler -- called when a terminated ChannelSession is completely removed from the LoginSession.
      // NB: This event happens AFTER Vivox5.ChannelSession.onSessionTerminated.
      console.log("onChannelSessionRemoved _loginSession:", _loginSession);
      console.log("onChannelSessionRemoved channelSession:", channelSession);
      this.vivoxState = this.cntStatus.dcnted;
      this.liveUsers = [];
      if (this.reConnect) {
        console.log("vivox reConnect:" + this.receiveChannel);
        this.reConnect = false;
        this.joinChannel();
      }
    },
    onDirectedTextMessage: function (loginSession, textMessage) {
      console.log("onDirectedTextMessage:", textMessage);
    },
    onIncomingSubscriptionRequest: function (
      _loginSession,
      buddyAccountId,
      autoAccepted
    ) {
      console.log("onIncomingSubscriptionRequest:", buddyAccountId);
      console.log("onIncomingSubscriptionRequest:", autoAccepted);
    },
    onBuddyPresence: function (
      _loginSession,
      buddyAccountId,
      presenceLocations
    ) {
      console.log("onBuddyPresence:", buddyAccountId);
      console.log("onBuddyPresence:", presenceLocations);
    },
    onBuddyAdded(_loginSession, buddyAccountId) {
      console.log("onBuddyAdded:", buddyAccountId);
    },
    onBuddyRemoved(_loginSession, buddyAccountId) {
      console.log("onBuddyRemoved:", buddyAccountId);
    },
    onGetUserMediaSuccess: function (stream) {
      // Save reference to the local audio stream (from the microphone) in the global object.
      // gameInstance.SendMessage(VOICECHAT_TARGET, "OnGetUserMedia", "true");
      console.log("onGetUserMediaSuccess");
      this.streamLocal = stream;
      this.channelSession.streamLocal = this.streamLocal;
      // if (micEnabled && channelSession && streamLocal)
      // {
      //   channelSession.streamLocal = streamLocal;
      // }
      eventBus.$emit("updatePermission", true);
      console.log("inputDevice:" + stream.getAudioTracks()[0].label);
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          for (var i = 0; i < devices.length; i++) {
            if (devices[i].kind == "audiooutput") {
              console.log("outputDevice:" + devices[i].label);
              break;
            }
          }
        })
        .catch(function (err) {
          console.log("outputDevice:" + err);
        });
    },
    //session and channel
    joinChannel: function () {
      if (this.receiveChannel == "") {
        console.error("joinChannel name is empty string");
        return;
      }

      if (this.vivoxState == this.cntStatus.cnted) {
        console.warn("vivoxState is connected, return");
        return;
      }

      if (this.clientState == this.cntStatus.dcnted) {
        this.reConnect = true;
        this.vivoxSDKInit(this.uid);
        return;
      } else if (this.clientState == this.cntStatus.cnting) {
        this.reConnect = true;
        this.clientCntingCount++;
        console.warn("joinChannel name is empty string");
        return;
      }

      this.vivoxState = this.cntStatus.cnting;
      this.channelCntingTimerFun = setInterval(this.channelCntingCount, 1000);
      try {
        this.createChannelSession(
          this.receiveChannel,
          "g",
          this.VOICECHAT_REALM,
          "dumb"
        );
        this.clientCntingCount = 0;
      } catch (error) {
        this.vivoxState = this.cntStatus.dcnted;
        console.error(error);
      }
    },
    leaveChannelSession: function (reConnect = false) {
      if (this.vivoxState=="CONNECTED") {
        this.vivoxState = this.cntStatus.dcnting;
        this.channelDisCntingTimerFun = setInterval(this.channelDisCntingCount, 1000);
        this.reConnect = reConnect;
        this.channelSession.disconnect();
      }
    },
    createChannelSession: function (
      channelName,
      channelType,
      realm,
      overrideSessionMode = undefined
    ) {
      // Here we create the ChannelSession -- the voice and text communication conference.
      // Steps:
      // 1. Instantiate Vivox5.ChannelSession object.
      // 2. Set callback functions for essential events (established/terminated, remote media stream received, participant added/updated/removed, text message received, etc.).
      // 3. Start ChannelSession.
      // This function is called when a user clicks the 'Join channel' button (see function onClickJoin below).
      // NB: the current SDK version does not support multiple simultaneous ChannelSessions. See also: WRT-25 Implement joining multiple audio channels in WebRTC Demo

      let that = this;
      if (!this.streamLocal) {
        let silence = () => {
          let ctx = new AudioContext(),
            oscillator = ctx.createOscillator();
          let dst = oscillator.connect(ctx.createMediaStreamDestination());
          oscillator.frequency.value = 1; // 1Hz should be inaudible
          oscillator.start();
          return Object.assign(dst.stream.getAudioTracks()[0], {
            enabled: false,
          });
        };

        let silenceTrack = (...args) => new MediaStream([silence()]);

        this.streamLocal = silenceTrack();
      } else {
        this.streamLocal.getAudioTracks().forEach(function (track) {
          track.enabled = that.micEnabled;
        });
      }

      if (!this.streamLocal) {
        this.vivoxState = this.cntStatus.dcnted;
        console.error(
          "Cannot start ChannelSession: local audio stream was not initialized. Please allow the page to access the microphone when the page is loading."
        );
        return;
      }

      // Create Vivox5.ChannelSession object inside the established loginSession.
      var channelId = new Vivox5WebRTC.Vivox5.ChannelId(
        this.ACCESS_TOKEN_ISSUER,
        channelName,
        realm,
        channelType
      );
      this.channelSession = this.loginSession.getChannelSession(channelId);
      if (!this.channelSession) {
        this.vivoxState = this.cntStatus.dcnted;
        console.error("getChannelSession failed, see details in the log");
        return null;
      }

      // overrideRTCPCMode is an experimental feature, it can be removed from the production version. Don't use this in the production code.
      if (overrideSessionMode) {
        this.channelSession.overrideRTCPCMode = overrideSessionMode;
      }

      // Setup channelSession callbacks
      this.channelSession.onSessionEstablished = this.onSessionEstablished;
      this.channelSession.onSessionTerminated = this.onSessionTerminated;
      this.channelSession.onRemoteStream = this.onRemoteStream;
      this.channelSession.onParticipantAdded = this.onParticipantAdded;
      this.channelSession.onParticipantUpdated = this.onParticipantUpdated;
      this.channelSession.onParticipantRemoved = this.onParticipantRemoved;
      this.channelSession.onChannelTextMessage = this.onChannelTextMessage;

      // Set local media stream (from the microphone)
      this.channelSession.streamLocal = this.streamLocal;

      // Start channelSession
      let connectAccessToken = this.channelSession.getConnectToken(
        this.ACCESS_TOKEN_KEY,
        this.ACCESS_TOKEN_DURATION
      );
      if (!this.channelSession.connect(true, true, connectAccessToken)) {
        channelSession = null;
        return null;
      }

      return this.channelSession;
    },
    onSessionEstablished: function (_channelSession) {
      console.log("onSessionEstablished", _channelSession);
      this.vivoxState = this.cntStatus.cnted;
      this.wdenterChannelName = this.channelSession.channel.name;
      this.channelCntingTimer=0;
      clearInterval(this.channelCntingTimerFun);
      if (!this.micEnabled) {
        this.disableMic();
      }
    },
    onSessionTerminated: function (_channelSession) {
      this.vivoxState = this.cntStatus.dcnted;
      this.channelDisCntingTimer=0;
      clearInterval(this.channelDisCntingTimerFun);
      console.log("onSessionTerminated", _channelSession);
    },
    onRemoteStream: function (channelSession, stream, idRTCPC) {
      // Vivox5.ChannelSession.onRemoteStream callback handler -- called when a new audio stream is added to the ChannelSession.
      // NB: THIS IS MOST IMPORTANT EVENT OF THE ChannelSession that the web application MUST HANDLE!
      // The web application MUST create new <audio/> HTML element on the web page and connect it with the 'stream' parameter passed from the SDK.
      // NB: MULTIPLE onRemoteStream events can happen in one ChannelSession! The web application MUST create separate <audio/> element for each event!

      // var elSessionItem = this.getSessionItem(channelSession, false);
      // var elsContainerAudio = elSessionItem.getElementsByClassName('audiolist');
      // if (!elsContainerAudio || elsContainerAudio.length < 1) {
      //   alert('Fatal error: audiolist not found on the page for the session ' + channelSession.channel.name);
      //   return;
      // }
      // var elContainerAudio = elsContainerAudio[0]; // Per-session audio container

      // var elAudio = elContainerAudio.querySelector('audio[data-rtcpcid="' + idRTCPC + '"][data-streamid="' + stream.id + '"][data-sessionid="' + channelSession.channel.name + '"]');
      // if (elAudio) {
      //   // should not happen
      //   return;
      // }
      console.log("onRemoteStream add audio");
      if(this.subscribeMode){
        console.log(JSON.stringify(this.Obj2KeyValue(channelSession)));
        console.log(JSON.stringify(this.Obj2KeyValue(stream)));
        console.log(idRTCPC);
        var elsContainerAudio = document.getElementsByClassName("audiolist")[0];
        let elAudio = document.createElement("audio");
        elAudio.setAttribute("data-rtcpcid", idRTCPC);
        elAudio.setAttribute("data-streamid", stream.id);
        elAudio.setAttribute("data-sessionid", channelSession.channel.name);
        elAudio.setAttribute("autoplay", 1);
        elAudio.controls = false;
        elAudio.srcObject = stream;

        elsContainerAudio.appendChild(elAudio);
        Vivox5WebRTC.Vivox5.log(
          "DEMOAPP",
          "Created html audio element for stream " +
            stream.id +
            " in RTPCP " +
            idRTCPC +
            " of ChannelSession " +
            channelSession.channel.name
        );
      }
    },
    onParticipantAdded: function (channelSession, participant) {
      if(this.subscribeMode){
        console.log("onParticipantAdded:", participant);
        let data=this.Obj2KeyValue(participant)
        console.log(JSON.stringify(data));
        if (participant.account.name != this.udiRandom) {
          this.liveUsers.push(participant);
          console.log("live user push:" + participant.account.name);
          if(this.spatial){
            setTimeout(() => {
              channelSession.muteForMe(true, participant);
            }, 600);
          }
        }
      }
    },
    onParticipantUpdated: function (channelSession, participant) {
      console.log("onParticipantUpdated:", participant);
    },
    onParticipantRemoved: function (channelSession, participant) {
      if(this.subscribeMode){
        console.log("onParticipantRemoved:", participant);
        console.log("remove index:", this.liveUsers.indexOf(participant));
        this.liveUsers.splice(this.liveUsers.indexOf(participant), 1);
      }
      
    },
    onChannelTextMessage: function (channelSession, message) {
      console.log("onChannelTextMessage:", message);
    },
    getSessionItem: function (channelSession, giveMeInnerList = false) {
      // Find a session element of sessions list

      var sel =
        '#sessionlist > li.sessitem[data-sessionid="' +
        channelSession.channel.name +
        '"]';
      if (giveMeInnerList) {
        sel += " > ul.partslist";
      }

      var sessionItem = document.querySelector(sel);
      return sessionItem;
    },
    enableMic: function () {
      if (this.channelSession) {
        if (this.streamLocal) {
          console.log("v enableMic");

          this.streamLocal.getAudioTracks().forEach(function (track) {
            track.enabled = true;
          });
        } else this.initUserMedia();
      }
    },
    disableMic: function () {
      if (this.channelSession) {
        console.log("v disableMic");

        this.streamLocal.getAudioTracks().forEach(function (track) {
          track.enabled = false;
        });
      }
    },
    setMuteForMe: function (speakers) {
      console.log(speakers);
      for (let i = 0; i < this.liveUsers.length; i++) {
        for (let j = 0; j < speakers.length; j++) {
          if (
            this.liveUsers[i].account.name.indexOf(
              speakers[j].uid.toString()
            ) == 1
          ) {
            /* true = mute, false = unmute */
            console.log("set uid:" + speakers[j].uid + ",muted:" + speakers[j].muted + ",lastGain:" + speakers[j].lastGain + ",muteValue:" + this.muteValue)
            this.$set(this.liveUsers[i], 'clientMuted', speakers[j].muted);
            this.$set(this.liveUsers[i], 'clientLastGain', speakers[j].lastGain);
            if (speakers[j].muted) {
              this.channelSession.muteForMe(false, this.liveUsers[i]);
              this.channelSession.muteForMe(true, this.liveUsers[i]);
            } else {
              if (speakers[j].lastGain > this.muteValue) {
                this.channelSession.muteForMe(true, this.liveUsers[i]);
                this.channelSession.muteForMe(false, this.liveUsers[i]);
              } else {
                this.channelSession.muteForMe(false, this.liveUsers[i]);
                this.channelSession.muteForMe(true, this.liveUsers[i]);
              }
            }
            break;
          }
        }
      }
    },
    setMuteForMeByName: function (name, muted = true) {
      for (let i = 0; i < this.liveUsers.length; i++) {
        if (this.liveUsers[i].account.name.indexOf(name) >= 0) {
          this.channelSession.muteForMe(muted, this.liveUsers[i]);
        }
      }
    },
    log: function (date, subsystem, msg) {
      //var timeString = date.toISOString();
      var timeString =
        this.numberToString(date.getHours(), 2) +
        ":" +
        this.numberToString(date.getMinutes(), 2) +
        ":" +
        this.numberToString(date.getSeconds(), 2) +
        "." +
        this.numberToString(date.getMilliseconds(), 3);

      var msgFull = timeString + " [" + subsystem + "] " + msg;
      console.log(msgFull);

      /*
      This was log as <pre>.
      var elementLog = document.getElementById('log');
      if (elementLog) {
        elementLog.textContent += msgFull + '\n';
        elementLog.scrollTop = elementLog.scrollHeight;
      }
      */

      var elLogContainer = document.getElementById("log");

      if (elLogContainer) {
        var elLogRecord = document.createElement("div");
        var elTime = document.createElement("span");
        var elSubsystem = document.createElement("span");
        var elMessage = document.createElement("span");

        elLogRecord.className = "logrecord";
        elTime.className = "logtime";
        elSubsystem.className = "logsubsystem";
        elMessage.className = "logmessage";

        elTime.textContent = timeString;
        elSubsystem.textContent = subsystem;
        elSubsystem.setAttribute("data-subsystem", subsystem);
        elMessage.textContent = msg;

        elLogRecord.appendChild(elTime);
        elLogRecord.appendChild(elSubsystem);
        elLogRecord.appendChild(elMessage);
        elLogContainer.appendChild(elLogRecord);

        if (LOG_RECORDS_LIMIT && LOG_RECORDS_LIMIT >= 1) {
          while (elLogContainer.childNodes.length > LOG_RECORDS_LIMIT) {
            elLogContainer.removeChild(elLogContainer.firstChild);
          }
        }

        elLogContainer.scrollTop = elLogContainer.scrollHeight;
      }
    },
    logTraffic: function (msg) {
      console.log(msg + "\n");
    },
    numberToString: function (n, minLength = 1) {
      var s = "" + n;
      while (s.length < minLength) {
        s = "0" + s;
      }
      return s;
    },
    getRndInteger: function (min, max) {
      return Math.ceil(Math.random() * (max - min)) + min;
    },
    updateValue: function (valueName, val) {
      this.$emit("update:" + valueName, val);
    },
    receiveDeviceId: function () {
      eventBus.$on("updateInputDeviceId", (deviceId) => {
        this.inputDeviceId = deviceId;
        console.log(this.inputDeviceId);
      });
    },
    closeDevice: function(){
      this.$emit("update:micEnabled", false);
    },
    Obj2KeyValue: function (obj, depth=0) {
      if(depth>=this.obj2KeyValueDepth){
        return;
      }
      let newObj={};
      for(var key in obj){  
        var property=obj[key];
        if(typeof(property)=='function'){
          continue;
        }else if(typeof(property)=='object'){
          newObj[key]=this.Obj2KeyValue(property, depth++);
        }else{
          newObj[key]=property; 
        }
      }
      return newObj;
    }
  },
};
</script>

<style scoped>
.hideTemplate {
  display: none;
}
.vLiveUsers {
  max-height: 700px;
  overflow-y: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/Vivox.vue